import {BASEHOST_CLOUDSHARE, BASEHOST_ARCHIVE} from '../../../pub/config/baseHost'

export const queryDetail = BASEHOST_ARCHIVE + "/dishListDetail/queryDetail";// 私人订制
export const queryDetailHdl = BASEHOST_ARCHIVE + "/dishListDetail/queryDetailHdl";// 私人订制
export const historyPot = BASEHOST_CLOUDSHARE + "/shop/dish/historyPot";// 历史锅底





// WEBPACK FOOTER //
// ./src/components/taste/config/api.js